const rasterTileUrl =
  process.env.REACT_APP_MAP_TILES_URL ||
  "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

const hasMapboxToken = Boolean(process.env.REACT_APP_MAPBOX_TOKEN);
const useRasterMap =
  process.env.REACT_APP_USE_RASTER_MAP === "true" || !hasMapboxToken;

export const MAP_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || "";

export const MAP_STYLE = useRasterMap
  ? {
      version: 8,
      sources: {
        "raster-tiles": {
          type: "raster",
          tiles: [rasterTileUrl],
          tileSize: 256,
          attribution: "© OpenStreetMap",
        },
      },
      layers: [
        {
          id: "simple-tiles",
          type: "raster",
          source: "raster-tiles",
          minzoom: 0,
          maxzoom: 19,
        },
      ],
    }
  : process.env.REACT_APP_MAP_STYLE || "mapbox://styles/mapbox/streets-v11";

export const MAP_DIRECTIONS_ENABLED =
  process.env.REACT_APP_MAP_DIRECTIONS_URL?.length > 0;

export const fetchDrivingRoute = async (axios, origin, destination) => {
  const directionsUrl = process.env.REACT_APP_MAP_DIRECTIONS_URL;
  if (!directionsUrl || !origin || !destination) {
    return null;
  }

  const response = await axios.get(directionsUrl, {
    params: {
      origin: `${origin[0]},${origin[1]}`,
      destination: `${destination[0]},${destination[1]}`,
    },
  });

  return response?.data?.routes?.[0]?.geometry?.coordinates ?? null;
};
